<template>
  <div>
    <v-card>
      <v-layout wrap>
        <v-flex xs10>
          <v-tabs
            id="usertype"
            color="grey lighten-3"
            :value="botType"
            :slider-color="$vuetify.theme.primary"
            @change="changeType"
          >
            <v-tab ripple :key="'botnoreply'" :href="'#botnoreply'" style="position: relative">
              <div>
                บอทตอบไม่ได้
                <!-- <div
                  class="newnotifycount"
                  v-if="chatnotify && chatnotify.admin && chatnotify.admin != '0' && isTicketAdmin"
                >
                  {{ numberFormat(chatnotify.admin) }}
                </div> -->
              </div>
            </v-tab>
            <v-tab ripple :key="'botreply'" :href="'#botreply'" style="position: relative">
              <div>
                ตอบโดยบอท
                <!-- <div
                  class="newnotifycount"
                  v-if="
                    chatnotify &&
                      chatnotify.bot &&
                      chatnotify.bot != '0' &&
                      isTicketAdmin &&
                      selectedBot.pageid != '100207768987988'
                  "
                >
                  {{ numberFormat(chatnotify.bot) }}
                </div> -->
              </div>
            </v-tab>
          </v-tabs>
          <!-- <v-layout wrap>
            <v-flex xs6 class="text-xs-center py-2" style="border-right: 1px solid #000">
              <span>บอทตอบไม่ได้</span>
            </v-flex>
            <v-flex xs6 class="text-xs-center py-2">
              <span>ตอบโดยบอท</span>
            </v-flex>
          </v-layout> -->
        </v-flex>
        <v-flex xs2 class="text-xs-center grey lighten-3" color="">
          <v-btn icon ripple @click="$emit('onRefresh', true)">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['isCurrentBotType'],
  data() {
    return {
      botType: null
    }
  },
  mounted() {
    if (this.isCurrentBotType) {
      this.botType = 'botreply'
    } else {
      this.botType = 'botnoreply'
    }
  },
  methods: {
    changeType(name) {
      let botreply = null
      if (name == 'botreply') {
        botreply = true
      } else if (name == 'botnoreply') {
        botreply = false
      }
      this.$emit('setCommentType', botreply)
      // this.$store.commit('SET_LIVECHAT_TYPE', name)
      // this.$store.dispatch('updateLivechatUser', null)
      // this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentTab.vue